import React from 'react';
import Highcharts from 'highcharts';
import xrange from 'highcharts/modules/xrange';
import loading from '../loading.svg';


class XRangeChart extends React.PureComponent {

    initialize() {

        xrange(Highcharts);
        Highcharts.setOptions({
            global: {
                useUTC: false
            },
            lang: {
                loading: `<img src="${loading}" style="width:40px;">`
            }
        });

        this.chart = Highcharts.chart(this.props.serial, {
            chart: {
                type: 'xrange',
                style: {
                    fontFamily: 'inherit'
                }
            },
            credits: {
                enabled: false
            },
            title: {
                text: null
            },
            xAxis: {
                type: 'datetime'
            },
            yAxis: {
                title: {
                    text: ''
                },
                categories: ['data'],
                reversed: true
            },
            legend: {
                enabled: false
            },
            loading: {
                labelStyle: {
                    backgroundColor: 'rgba(255,255,255,0.5)',
                    opacity: 1,
                    position: 'relative',
                    display: 'inline-block',
                    // width: '136px',
                    // height: '100px',
                    top: '45%'
                }
            },
            series: [{
                data: this.props.data
            }],
            exporting: {
                enabled: false
            }
        });
    }

    componentDidMount() {
        this.initialize();
        if (!this.props.data) {
            this.chart.showLoading();
            return;
        }
    }

    componentDidUpdate() {
        if (!this.props.data) {
            this.chart.showLoading();
            return;
        }
        this.initialize();
    }

    render() {

        return <div id={this.props.serial} style={{ 'height': '150px' }}></div>;

    }
}

export default XRangeChart;